export default __webpack_public_path__ + "static/media/img-one.6ddc32f8.png";